import { TOGGLE_OPTIONAL_MAP_ATTRIBUTION, CHANGE_MAP_ATTRIBUTION_POSITION } from './constants';
import { changePreviewHiddenComponents } from '../../actions';
export const toggleOptional = (isChecked, componentIdent) => (dispatch) => {
    dispatch({
        type: TOGGLE_OPTIONAL_MAP_ATTRIBUTION,
        isHidden: !isChecked,
        componentIdent,
    });
    dispatch(changePreviewHiddenComponents());
};
export const changePosition = (showOverMap, componentIdent) => (dispatch) => {
    dispatch({
        type: CHANGE_MAP_ATTRIBUTION_POSITION,
        showOverMap: showOverMap,
        componentIdent,
    });
};
//# sourceMappingURL=actions.js.map